export const SourceTypeMap = {
    Organic: "organic",
    Paid: "paid",
    Total: "all",
};

export enum SourceType {
    ORGANIC = "Organic",
    PAID = "Paid",
    TOTAL = "Total",
}

export const sourceTypeTextKeys = {
    [SourceType.ORGANIC]: "common.organic",
    [SourceType.PAID]: "common.paid",
    [SourceType.TOTAL]: "common.total",
};

export enum EKeywordTabs {
    Total,
    Organic,
    Paid,
}
